import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { useRouter } from 'vue-router/composables';

import { CollectionType } from '@/enums/collection-type';
import { calculateUrl } from '@/helpers/state-helper';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';

import BasicButton from '@/ui-components/BasicButton.vue';

import { useConstantStore } from '@/helpers/composables/useStores';
import { useI18n } from '@/helpers/composables/useI18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'EndCard',
  setup(__props) {

const router = useRouter();
const { tc } = useI18n();

const { providersByShortName } = useConstantStore();

const backgroundUrl = `url(/${ASSETS_DIR}/img/home/bg-tiles/bg-tiles.png)`;

const title = computed(() => {
	return [
		tc('WEBAPP_DISCOVER_ENDCARD_HEADING_1'),
		tc('WEBAPP_DISCOVER_ENDCARD_HEADING_2'),
		tc('WEBAPP_DISCOVER_ENDCARD_HEADING_3'),
		tc('WEBAPP_DISCOVER_ENDCARD_HEADING_4'),
	][Math.floor(Math.random() * 4)];
});

const buttons = computed(() => {
	return [
		{
			text: tc('WEBAPP_DISCOVER_ENDCARD_BUTTON_NEW'),
			link: calculateUrl(router, undefined, CollectionType.NEW, {}, providersByShortName.value),
			source: 'new' as const,
		},
		{
			text: tc('WEBAPP_DISCOVER_ENDCARD_BUTTON_POPULAR'),
			link: calculateUrl(router, undefined, CollectionType.POPULAR, {}, providersByShortName.value),
			source: 'popular' as const,
		},
	];
});

function trackButtonClick(source: 'new' | 'popular') {
	TrackingHelper.trackEvent('userinteraction', {
		action: 'click',
		property: 'discovery-end-card',
		label: `${source}-button`,
	});
}

return { __sfc: true,router, tc, providersByShortName, backgroundUrl, title, buttons, trackButtonClick, BasicButton }
}

})